import PayWithPoints from "../components/UI/payment-methods/PayWithPoints";
import { getEnvironmentConfiguration, isLocalhost, isProdEnvironment } from "./environments";
import Global from "./global";

const queryParams = new URLSearchParams(window.location.search);

export const setSteps = () => {
  let hotelRIDOnlineKiosk = queryParams.get("hotelRIDOnlineKiosk");
  let apHotelEmployeeName = queryParams.get("apHotelEmployeeName");
  // const steps = ['product', 'secondaryProduct', 'qbrEligibility', 'personalDetail', 'address', 'secondaryPersonalDetail', 'secondaryAddress', 'review', 'payment','confirmation', 'explore'];
  let steps;

  if (hotelRIDOnlineKiosk && apHotelEmployeeName) {
    steps = ["product", "personalDetail", "payment"];
  } else {
    steps = ["product", "personalDetail", "review", "payment"];
  }
  return steps;
};

const lookupCountry = (getUrlPathName) => {
  let getCountry = getUrlPathName.split("/")[1];
  let selectedCountry = null;
  let countryList = Global.COUNTRY_LIST;
  for (let i = 0; i < countryList.length; i++) {
    if (
      getCountry === countryList[i].code ||
      getCountry === countryList[i].code.toUpperCase()
    ) {
      selectedCountry = countryList[i];
      break;
    }
  }
  if (!selectedCountry) {
    for (let i = 0; i < countryList.length; i++) {
      if (countryList[i].code == "en") {
        selectedCountry = countryList[i];
        break;
      }
    }
  }
  return selectedCountry;
};


const standaloneProducts = (products, non_standalone) => {
  let productsArray = [];
  for (let i = 0; i < products.item_groups.length; i++) {
    let product = products.item_groups[i];
    if (product.non_standalone === non_standalone) {
      productsArray.push(product);
    }
  }

  return productsArray;
};

const Helper = {
  getUrl: function () {
    return getEnvironmentConfiguration()
  },

  jsonToUrlParameters: function (json) {
    if (json) {
      return (
        "?" +
        Object.entries(json)
          .map((e) => e.join("="))
          .join("&")
      );
    }
  },

  voucherBenefitsChecker: function (region) {
    let result;
    switch (region.toLowerCase()) {
      case "en":
        result = [{ explorer: false }, { discovery: false }];
        break;
      case "au":
        result = [{ explorer: false }, { discovery: false }];
        break;
      case "nz":
        result = [{ explorer: false }, { discovery: false }];
        break;
      case "hk":
        result = [{ explorer: false }, { discovery: false }];
        break;
      case "th":
        result = [{ explorer: true }, { discovery: false }];
        break;
      case "fj":
        result = [{ explorer: true }, { discovery: false }];
        break;
      case "cn":
        result = [{ explorer: false }, { discovery: false }];
        break;
      case "id":
        result = [{ explorer: true }, { discovery: true }];
        break;
      case "vn":
        result = [{ explorer: true }, { discovery: false }];
        break;
      case "ph":
        result = [{ explorer: true }, { discovery: false }];
        break;
      case "sg":
        result = [{ explorer: true }, { discovery: true }];
        break;
      case "my":
        result = [{ explorer: true }, { discovery: true }];
        break;
      case "tw":
        result = [{ explorer: false }, { discovery: false }];
        break;
      case "mo":
        result = [{ explorer: true }, { discovery: false }];
        break;
      case "in":
        result = [{ explorer: true }, { discovery: false }];
        break;
      case "kr":
        result = [{ explorer: false }, { discovery: false }];
        break;
      default:
        result = [{ explorer: false }, { discovery: false }];
    }
    return result;
  },

  urlParametersToJson: function (urlParams) {
    if (urlParams) {
      return JSON.parse(
        '{"' +
        urlParams.substring(1).replace(/&/g, '","').replace(/=/g, '":"') +
        '"}',
        function (key, value) {
          return key === "" ? value : decodeURIComponent(value);
        },
      );
    }
  },

  locationSelect: function () {
    const selectedCountry = lookupCountry(window.location.pathname);
    let selected = selectedCountry;
    if (
      !isProdEnvironment()
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      const overrideCode = urlParams.get("overrideCode");
      const overrideLabel = urlParams.get("overrideLabel");

      selected = {
        code: overrideCode || (isLocalhost() ? "au" : selectedCountry.code),
        label:
          overrideLabel ||
          (isLocalhost() ? "Australia" : selectedCountry.label),
      }; //Test
    }
    let locationParams = {};
    if (selected) {
      locationParams = {
        country: selected.code,
      };
    }
    return locationParams;
  },

  lookupCurrentCountry: function () {
    let getUrlPathName = window.location.pathname;
    let getCountry = getUrlPathName.split("/")[1];
    let selectedCountry = null;
    let countryList = Global.COUNTRY_LIST;
    if (isLocalhost()) {
      selectedCountry = {
        code: "au",
        label: "Australia",
      }; //Test
    } else {
      let found = false;
      for (let i = 0; i < countryList.length; i++) {
        if (
          getCountry === countryList[i].code ||
          getCountry === countryList[i].code.toUpperCase()
        ) {
          found = true;
          selectedCountry = countryList[i];
          break;
        }
      }

      if (!found) {
        for (let i = 0; i < countryList.length; i++) {
          if (countryList[i].code == "en") {
            selectedCountry = countryList[i];
            break;
          }
        }
      }
    }
    return selectedCountry;
  },

  checkCoupon: function (product, coupon) {
    let couponObj = coupon && coupon.length ? JSON.parse(coupon) : coupon;
    if (
      couponObj &&
      couponObj.item_group_id &&
      product.item_group_id === couponObj.item_group_id
    ) {
      let tax_rate =
        parseFloat(product.tax_amt || product.tax_amount) /
        parseFloat(product.purchase_price);
      let rate = parseFloat(couponObj.discount_rate);
      let total = 0;

      if (couponObj.discount_type == "percent") {
        let discount_amt = parseFloat(product.purchase_price) * (rate / 100);
        total = parseFloat(product.purchase_price) - discount_amt;
        total += total * (!isNaN(tax_rate) ? tax_rate : 0);
      } else if (couponObj.discount_type == "flat") {
        let discount_amt = rate;
        total = parseFloat(product.purchase_price) - discount_amt;
        total += total * (!isNaN(tax_rate) ? tax_rate : 0);
      }

      return {
        exists: true,
        discountType: couponObj.discount_type,
        total: total,
      };
    }

    return false;
  },

  // legacy PWP
  checkPwp: function (product, isUserLogged, locationData, bcs) {
    let BC = queryParams.get("bc");
    let hotelRIDOnlineKiosk = queryParams.get("hotelRIDOnlineKiosk");
    let apHotelEmployeeName = queryParams.get("apHotelEmployeeName");
    let pMethod = locationData.PaymentMethod.PayWithPoints;
    let pMethodBC = pMethod ? pMethod.bc : null;
    let bcExist;
    let paramBC = pMethod ? pMethodBC.includes(BC) : null;

    if (hotelRIDOnlineKiosk && apHotelEmployeeName) {
      //for hotels
      // if it's hotel check the points.
      return {
        exists: false,
        points: "",
      };
    } else {
      if (product.points_value && bcs) {
        // first check; check the product if it has points
        let pointConsumedExist = false;
        let PWPexist = "PayWithPoints" in locationData.PaymentMethod;
        let priceLevel = "";
        let pointsChecker = "";
        let itemGroupCheck = "";

        Object.values(bcs)?.map((business_category, index) => {
          // loop through BCS
          priceLevel = business_category.price_level_text;
          if (business_category.item_groups) {
            business_category.item_groups.map((ig, i) => {
              if (product.item_group_id === ig) {
                itemGroupCheck = true;
              }
              return itemGroupCheck;
            });
          }
          if (
            pMethod &&
            pMethodBC.includes(business_category.business_category_id)
          ) {
            bcExist = true; //if PWP BC has the business category id
          } else {
            bcExist = false;
          }
          if (business_category.price_level_text === "pwp") {
            if (
              business_category.points_type_id &&
              business_category.points_type_text
            ) {
              pointConsumedExist = true;
            } else {
              pointConsumedExist = false;
            }
          }
          if (BC) {
            if (pointConsumedExist && paramBC && bcExist && PWPexist) {
              var points = product.points_value;
              return (pointsChecker = {
                exists: true,
                points: points,
              });
            } else {
              pointsChecker = false;
            }
          } else {
            if (pointConsumedExist && itemGroupCheck) {
              var points = product.points_value;
              return (pointsChecker = {
                exists: true,
                points: points,
              });
            } else {
              pointsChecker = false;
            }
          }
        });
        return pointsChecker;
      }
    }
    return false;
  },

  newpwpCheck: function (product, isUserLogged, locationData, bcs) {
    let BC = queryParams.get("bc");
    let hotelRIDOnlineKiosk = queryParams.get("hotelRIDOnlineKiosk");
    let apHotelEmployeeName = queryParams.get("apHotelEmployeeName");
    let PWPexist = "PayWithPoints" in locationData.PaymentMethod;
    var pointsChecker;
    if (hotelRIDOnlineKiosk && apHotelEmployeeName) {
      //for hotels
      // if it's hotel check the points.
      return {
        exists: false,
        points: "",
      };
    } else {
      if (PWPexist && !this.isQbr(locationData)) {
        // checks if PWP exist in location data
        let isPWPExclusive =
          locationData.PaymentMethod?.PayWithPoints.bc?.includes(BC)
            ? true
            : false;
        product.points_table_options?.map((item, index) => {
          // check if product has points table and return the points
          if (item.points_provider_id === "1" && item.points_type_id === "1") {
            if (item.points_type_text.toUpperCase() == "POINTS CONSUMED") {
              return (pointsChecker = {
                exists: true,
                points: item.points_value,
                isPWPExclusive: isPWPExclusive,
              });
            }
          }
          // else {
          //     console.log('is it going here 2')
          //     return pointsChecker = {
          //         "exists": false,
          //         "points": ''
          //     }
          // }
        });
      }
    }
    return pointsChecker === undefined ? false : pointsChecker;
  },

  filterProducts: function (bc, pricelevel, result, location_data) {
    let bcUrlParams = queryParams.get("bc");
    var isQbrReady;
    var virtualQbrItemGroup = {};
    let hotel =
      queryParams.get("hotelRIDOnlineKiosk") &&
        queryParams.get("apHotelEmployeeName")
        ? true
        : false;
    let isQbrExclusive;
    let isBasePriceQBR = bcUrlParams
      ? result.business_categories[bcUrlParams]?.business_category_id ===
      location_data.defaultPriceLevel
      : true; // Check if the BC is default Base price
    // let isQbrExclusive = bcUrlParams ? (result.business_categories[bcUrlParams]?.business_category_id !== location_data.qbrBusinessCategoryID.includes(bcUrlParams)) : true; // Check if the QBR BC is same as the params
    // let isQbrExclusive = bcUrlParams ? (location_data.qbrBusinessCategoryID && !location_data.qbrBusinessCategoryID.includes(bcUrlParams)) : true; // Check if the QBR BC is same as the params

    if (bcUrlParams) {
      if (location_data.qbrBusinessCategoryID === undefined || hotel) {
        isQbrExclusive = false;
      } else {
        isQbrExclusive =
          location_data.qbrBusinessCategoryID.includes(bcUrlParams);
      }
    } else {
      isQbrExclusive = false;
    }

    //BC scenario
    if (bc && !pricelevel) {
      // if bc // bc params
      let productArray = [];
      for (let bcCat in result.business_categories) {
        // console.log('bcCat', result.business_categories[BC])
        if (bcCat === bc) {
          for (let itemGroupId in result.business_categories[bcCat]
            .alternate_item_descriptions) {
            let qbrItemGroup = {};
            for (let i = 0; i < result.item_groups.length; i++) {
              let item_group = result.item_groups[i];
              item_group.isSelected = false;
              item_group.isQbr = false;
              item_group.salesType =
                result.business_categories[bcCat].sales_type_text;
              item_group.priceLevel =
                result.business_categories[bcCat].price_level_text;
              // if(itemGroupId === item_group.item_group_id && (isQbrExclusive || hotel)) {
              if (itemGroupId === item_group.item_group_id && !isQbrExclusive) {
                if (
                  result.business_categories[bcCat].alternate_item_descriptions[
                  itemGroupId
                  ]
                ) {
                  item_group.item_group_description =
                    result.business_categories[
                      bcCat
                    ].alternate_item_descriptions[itemGroupId];
                  if (bcCat == "1009" || bcCat == "1010") {
                    item_group.component_description =
                      "2 Stay Plus complimentary nights (limited time only)";
                  }
                }
                // if(parseFloat(item_group.purchase_base_price) > parseFloat(item_group.purchase_price)){
                //     item_group.discount = true;
                // }
                productArray.push(item_group);
              } else if (
                item_group.item_group_id === "4291" &&
                (isBasePriceQBR || isQbrExclusive)
              ) {
                // 4291[Explorer] item group
                item_group.points_table_options?.map((item, index) => {
                  // check if product has points table and return the points
                  if (
                    item.points_provider_id ==
                    location_data.qbrPointsProviderId &&
                    item.points_type_id == location_data.qbrPointsTableId
                  ) {
                    //Points table id == 1 for QBR Earn
                    isQbrReady = true;
                    virtualQbrItemGroup = {
                      qbrPoints: item.points_value,
                      ...item_group,
                    };
                  }
                });
                // THIS WHIS WHERE WE ADD THE VIRTUAL QBR ITEM
              }
            }
          }
        }
      }

      let virtualQbrItemGroupItem = {
        item_group_id: virtualQbrItemGroup.item_group_id,
        item_group_name: virtualQbrItemGroup.item_group_name,
        item_group_description: "Accor Plus Business Explorer Membership",
        base_tax_amt: virtualQbrItemGroup.base_tax_amt,
        business_category_id: virtualQbrItemGroup.business_category_id,
        component_items: virtualQbrItemGroup.component_items,
        currency: virtualQbrItemGroup.currency,
        currency_id: virtualQbrItemGroup.currency_id,
        currency_text: virtualQbrItemGroup.currency_text,
        isSelected: virtualQbrItemGroup.isSelected,
        non_standalone: virtualQbrItemGroup.non_standalone,
        points_table_options: virtualQbrItemGroup.points_table_options,
        purchase_base_price: virtualQbrItemGroup.purchase_base_price,
        purchase_price: virtualQbrItemGroup.purchase_price,
        tax_amt: virtualQbrItemGroup.tax_amt,
        qbrPoints: virtualQbrItemGroup.qbrPoints,
        isQbr: true,
      };
      productArray.push(virtualQbrItemGroupItem);
      result.item_groups = productArray;
    }

    //END BC scenario

    //pricelevel scenario
    if (pricelevel) {
      let productArray = [];
      for (let bcCat in result.business_categories) {
        if (
          pricelevel &&
          result.business_categories[bcCat].price_level_text == pricelevel
        ) {
          for (let i = 0; i < result.item_groups.length; i++) {
            let item_group = result.item_groups[i];
            // Hide Points on Table if points availability is hide all on NS
            if (
              result.business_categories[bcCat].points_promo_visibility === "1"
            ) {
              item_group.points_table_options = [];
            }
            // console.log('qbr result.item_groups', item_group.item_group_id)
            item_group.isSelected = false;

            if (item_group.business_category_id === bcCat) {
              if (
                result.business_categories[bcCat].alternate_item_descriptions[
                item_group.item_group_id
                ]
              ) {
                item_group.item_group_description =
                  result.business_categories[bcCat].alternate_item_descriptions[
                  item_group.item_group_id
                  ];
              }
              productArray.push(item_group);
            }
          }
        } else {
          //productArray.push(item_group);
        }
      }
      result.item_groups = productArray;
    }
    //END pricelevel scenario

    //Hotel scenario
    if (hotel) {
      let productArray = [];
      for (let bcCat in result.business_categories) {
        let business_cat = result.business_categories[bcCat];
        for (let i = 0; i < business_cat.channel.length; i++) {
          if (business_cat.channel[i] && business_cat.channel[i] === "Hotel") {
            for (let j = 0; j < result.item_groups.length; j++) {
              let item_group = result.item_groups[j];
              item_group.isSelected = false;
              item_group.isQbr = false;
              if (bcCat === item_group.business_category_id) {
                productArray.push(item_group);
              }
            }
          }
        }
      }
      result.item_groups = productArray;
    }

    const list = standaloneProducts(result, false);

    return list;
    //END Hotel scenario
  },

  isVNCampaign: function () {
    const bcValue = queryParams.get("bc");
    const isVisaVietnam2025 = Number(bcValue) === 1363;
    return isVisaVietnam2025;
  },

  hotelDetected: function () {
    return queryParams.get("hotelRIDOnlineKiosk") &&
      queryParams.get("apHotelEmployeeName")
      ? true
      : false;
  },

  isQbr: function (item) {
    // var isQbrEligible;
    // if(queryParams.get('bc')) {
    //     isQbrEligible = (queryParams.get('bc') && queryParams.get('bc') === '596' ) ? true : false
    // } else {
    //     isQbrEligible = false;
    // }
    return queryParams.get("bc") &&
      item.qbrBusinessCategoryID?.includes(queryParams.get("bc"))
      ? true
      : false;
    // return false
  },

  isDBS: function () {
    let couponEmail = queryParams.get("email");
    let couponDBS = queryParams.get("coupon");

    let dbsObj = {
      email: couponEmail,
      coupon: couponDBS,
      status:
        couponDBS !== "" &&
        couponEmail !== "" &&
        couponDBS !== null &&
        couponEmail !== null,
    };

    return dbsObj;
  },

  isAMEX: function () {
    let AMEXBC = queryParams.get("bc");
    if (AMEXBC === null || AMEXBC === undefined) {
      return false;
    } else if (AMEXBC === "1232" || AMEXBC === "1358") {
      return true;
    } else {
      return false;
    }
  },

  isSCB: function () {
    let SCB_BC = queryParams.get("bc");
    if (SCB_BC === null || SCB_BC === undefined) {
      return false;
    } else if (SCB_BC === "1227" || SCB_BC === "1324") {
      return true;
    } else {
      return false;
    }
  },

  focLength: function (component_items) {
    let count = 0;

    if (component_items) {
      for (let i = 0; i < component_items.length; i++) {
        let component_item = component_items[i];

        if (component_item.component_item_name === "FOC") {
          count++;
        }
      }
    }
    return count;
  },

  getSteps: function (expression) {
    var steps = setSteps();
    let result;
    switch (expression) {
      case 1:
        result = steps[0]; //[Primary] Product
        break;
      // case 2:
      //     result = steps[1]; //[Secondary] Product
      //     break;
      // case 3:
      //     result = steps[2]; // QBR
      //     break;
      case 2:
        result = steps[1]; //[Primary] Personal Details
        break;
      // case 5:
      //     result = steps[4]; //[Primary] Address
      //     break;
      // case 6:
      //     result = steps[5]; //[Secondary] Personal Details
      //     break;
      // case 7:
      //     result = steps[6]; //[Secondary] Address
      //     break;
      case 3:
        result = steps[2]; //Reviews
        break;
      case 4:
        result = steps[3]; //Payment
        break;
      // case 10:
      //     result = steps[9]; //Confirmation
      //     break;
      case 11:
        result = steps[10]; //
        break;
      default:
        result = steps[0];
    }
    return result;
  },

  navigate: function (step) {
    let result;
    switch (step) {
      case 1:
        result = ""; //[Primary] Product
        break;
      // case 2:
      //     result ='#secondary-product-selection'; //[Secondary] Product
      //     break;
      // case 3:
      //     result = '#qbr-product-selection'; // QBR
      //     break;
      case 2:
        result = "/details"; //[Primary] Personal Details
        break;
      // case 5:
      //     result = '#primary-address'; //[Primary] Address
      //     break;
      // case 6:
      //     result = '#secondary-details'; //[Secondary] Personal Details
      //     break;
      // case 7:
      //     result = '#secondary-address'; //[Secondary] Address
      //     break;
      case 3:
        result = "/review"; //Reviews
        break;
      case 4:
        result = "/payment"; //Payment
        break;
      case 5:
        result = "/confirmation"; //Confirmation
        break;
      case 10:
        result = "/qbr"; //Confirmation
        break;
      default:
        result = "";
    }
    console.warn('pathname step', result)
    return result;
  },

  getStepsTitle: function (currentStep, languages) {
    let result;
    switch (currentStep) {
      case "product":
        result = languages.selectYourMembership
          ? languages.selectYourMembership
          : "Select your Membership";
        break;
      case "secondaryProduct":
        result = languages.selectYourSecondaryMembership
          ? languages.selectYourSecondaryMembership
          : "Select your Secondary membership";
        break;
      case "qbrEligibility":
        result = languages.confirmYourEligibility
          ? languages.confirmYourEligibility
          : "Confirm Your Eligibility";
        break;
      case "personalDetail":
        result = languages.primaryPersonalDetails
          ? languages.primaryPersonalDetails
          : "Personal Details";
        break;
      case "address":
        result = languages.primaryAddress
          ? languages.primaryAddress
          : "Your Address";
        break;
      case "secondaryPersonalDetail":
        result = languages.secondaryPersonalDetails
          ? languages.secondaryPersonalDetails
          : "Secondary Personal Details";
        break;
      case "secondaryAddress":
        result = languages.secondaryAddress
          ? languages.secondaryAddress
          : "Secondary Address";
        break;
      case "review":
        result = languages.reviewYourOrder
          ? languages.reviewYourOrder
          : "Review Your Order";
        break;
      case "payment":
        result = languages.selectPaymentMethod
          ? languages.selectPaymentMethod
          : "Select Payment Method";
        break;
      case "confirmation":
        result = languages.yourOrderIsConfirmed
          ? languages.yourOrderIsConfirmed
          : "Your order is confirmed";
        break;
      case "explore":
        result = languages.getReadyToExplore
          ? languages.getReadyToExplore
          : "Get ready to explore";
        break;
      default:
        result = languages.selectYourMembership
          ? languages.selectYourMembership
          : "Select your Membership";
    }
    return result;
  },

  getProgressBarWidth: function (currentStep) {
    var totalSteps = setSteps().length;
    var totalProgressWidth = 100;
    var progress = totalProgressWidth / totalSteps;
    let result;

    switch (currentStep) {
      case 11:
        result = 100;
        break;
      case currentStep:
        result = currentStep * parseInt(progress);
        break;
      default:
        return parseInt(progress);
    }

    return result;
  },

  getFormatDate: function (dateObj) {
    return (
      dateObj.getFullYear() +
      "-" +
      (dateObj.getMonth() + 1) +
      "-" +
      dateObj.getDate()
    );
  },

  characterLimit: function (name, value) {
    if (value) {
      if (name === "first_name" || name === "last_name") {
        return value.length > 25 ? false : true;
      } else if (name === "address") {
        return value.length > 32 ? false : true;
      } else {
        return true;
      }
    }
  },

  lookupSubsidiaryCountry: function (subsidiary) {
    let subId = subsidiary;
    let selectedCountry = null;
    for (let i = 0; i < Global.COUNTRY_LIST.length; i++) {
      if (subId == Global.COUNTRY_LIST[i].subsidiary) {
        selectedCountry = Global.COUNTRY_LIST[i];
        break;
      }
    }

    return selectedCountry;
  },

  deleteCookie: function (name) {
    let json = document.cookie.split("; ").reduce((prev, current) => {
      const [name, ...value] = current.split("=");
      prev[name] = value.join("=");
      return prev;
    }, {});

    if (json[name]) {
      document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
  },

  /******* GTM FUNCTIONS *******/
  gtmPageView: function (membershipType, pageCategory, loginstatus, userId) {
    // console.log("Global.GTM_ID", Global.GTM_ID);
    /*if(!window.dataLayer) {
            console.error("dataLayer not accessible.");
            return;
        }*/

    return {
      // gtmId: Global.GTM_ID,
      dataLayer: {
        event: "virtualPageview",
        membershipType: membershipType,
        pageCategory: pageCategory,
        loginstatus: loginstatus,
        userId: userId,
      },
    };
  },

  gtmEccomerceCheckoutView: function (step) {
    return {
      // gtmId: Global.GTM_ID,
      dataLayer: {
        event: step,
        stepsinfo: {
          step_name: "fragment name",
        },
      },
    };
  },

  gtmFunnelPage: function (
    currencyCode,
    checkoutStep,
    membershipType,
    page,
    paymentMethod,
    products,
  ) {
    /*if(!window.dataLayer) {
            console.error("dataLayer not accessible.");
            return;
        }*/
    return {
      // gtmId: Global.GTM_ID,
      dataLayer: {
        event: "virtualPageview",
        eeAction: "eeCheckout",
        currencyCode: currencyCode,
        checkoutStep: checkoutStep,
        membershipType: membershipType,
        page: page,
        paymentMethod: paymentMethod,
        products: products,
      },
    };
  },

  // ADD begin checkout Function

  gtmBeginCheckout: function (currencyCode, page, products) {
    return {
      dataLayer: {
        event: "begin_checkout",
        page: page,
        ecommerce: {
          items: products,
        },
      },
    };
  },

  gtmEcommerceCart: function (type, membershipType, products) {
    return {
      dataLayer: {
        event: type,
        type: membershipType,
        ecommerce: {
          items: products,
        },
      },
    };
  },

  gtmGeneralPageData: function () {
    return {
      dataLayer: {
        event: "general",
        generalinfo: {
          page_category: "registration",
        },
      },
    };
  },

  gtmUserData: function (membershipType, userId, loginStatus) {
    return {
      dataLayer: {
        event: "userData",
        userInfo: {
          membership_type: membershipType,
          user_id: userId,
          login_status: loginStatus,
        },
      },
    };
  },

  gtmGeneralCheckoutStep: function (eventName, fragmentName, step) {
    return {
      dataLayer: {
        event: eventName,
        stepsinfo: {
          step_name: fragmentName,
          step_number: step,
        },
      },
    };
  },

  gtmTransaction: function (transactionPayload) {
    /*if(!window.dataLayer) {
            console.error("dataLayer not accessible.");
            return;
        }*/

    const {
      currencyCode,
      membershipType,
      paymentMethod,
      transactionId,
      transactionTax,
      transactionTotal,
      products,
      coupon_code,
      countryCode,
      businessCategory,
      salesType,
    } = transactionPayload;

    let productsArray = [];

    for (let p = 0; p < products.length; p++) {
      productsArray.push({
        item_id: products[p].id,
        item_name: products[p].name,
        affiliation: "Accor Plus",
        coupon: coupon_code,
        item_category: products[p].category,
        currency: currencyCode,
        discount: "0.00",
        index: p,
        price: products[p].price,
        price_no_tax: products[p].price_no_tax,
        quantity: 1,
      });
    }

    if (window.google_tag_manager) {
      window.google_tag_manager[Global.GTM_ID].dataLayer.reset();
    }

    return {
      // gtmId: Global.GTM_ID,
      dataLayer: {
        event: "purchase",
        ecommerce: {
          transaction_id: transactionId,
          affiliation: "Accor Plus",
          value: transactionTotal,
          currency: currencyCode,
          coupon: coupon_code,
          items: productsArray,
          payment_type: paymentMethod,
          campaign_id: businessCategory,
          sales_type: salesType?.replace("#", "") || "",
        },
      },
    };
    //window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  },
  /******* END GTM FUNCTIONS *******/


  languageRegionSetter: function (locationParam) {
    const masterRegion = locationParam.country.toLowerCase();
    const isTranslateDisable = queryParams.get("isTranslateDisable") === "1";

    let regionSetter = masterRegion || "au";
    if (isLocalhost() && !isTranslateDisable) {
      return regionSetter;
    }
    const validRegions = ["au", "en", "id", "kr", "th", "vn"];
    const thaiLocalPathname = window.location.pathname === "/th/th/registration/";
    const vietnamLocalPathname =
      window.location.pathname === "/vn/vi/registration/";
    const indonesiaLocalPathname =
      window.location.pathname === "/id/id/registration/";

    if (
      !validRegions.includes(regionSetter) ||
      !thaiLocalPathname ||
      !vietnamLocalPathname ||
      !indonesiaLocalPathname
    ) {
      regionSetter = "en";
    }

    if (vietnamLocalPathname) regionSetter = "vn";
    else if (thaiLocalPathname) regionSetter = "th";
    else if (indonesiaLocalPathname) regionSetter = "id";
    // Fallback to 'en' if regionSetter is not valid or not a translated one
    if (!validRegions.includes(regionSetter)) regionSetter = "en";

    return regionSetter;
  }
};

export default Helper;
